"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _auth = require("../../redux/modules/auth");

var _LoginFailed = require("./LoginFailed");

var _LoginFailed2 = _interopRequireDefault(_LoginFailed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginFailedPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loginError: state.auth.loginError
  };
}, { resetLoginError: _auth.resetLoginError }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(LoginFailedPopup, _React$Component);

  function LoginFailedPopup(props) {
    (0, _classCallCheck3.default)(this, LoginFailedPopup);
    return (0, _possibleConstructorReturn3.default)(this, (LoginFailedPopup.__proto__ || (0, _getPrototypeOf2.default)(LoginFailedPopup)).call(this, props));
  }

  (0, _createClass3.default)(LoginFailedPopup, [{
    key: "isLoginError",
    value: function isLoginError(loginError) {
      if (!loginError) return false;
      if (!loginError.message) return false;

      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var loginError = this.props.loginError;


      if (this.isLoginError(loginError)) {
        this.props.resetLoginError();
        this.context.dialogs.custom(_react2.default.createElement(_LoginFailed2.default, (0, _extends3.default)({}, this.props, { message: loginError.message })));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var loginError = this.props.loginError;


      if (this.isLoginError(loginError)) {
        this.props.resetLoginError();
        this.context.dialogs.custom(_react2.default.createElement(_LoginFailed2.default, (0, _extends3.default)({}, this.props, { message: loginError.message })));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement("div", null);
    }
  }]);
  return LoginFailedPopup;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = LoginFailedPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginFailedPopup/LoginFailedPopup.jsx
// module id = 2860
// module chunks = 0